import { Component, OnInit } from '@angular/core';
import {gutil} from '../gutil';
import {HttpHeaders , HttpClient} from '@angular/common/http';
import * as AOS from 'aos';
import {SessionService} from '../services/session.service';
import {Router, ActivatedRoute} from '@angular/router';
import { faCheckCircle, faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
  })
export class LoginComponent implements OnInit {

    public faTimes = faTimes;
    public faTimesCircle = faTimesCircle;
    public faCheckCircle = faCheckCircle;
    public login = {email: "", password: ""};
    public login_fail_msg : string = "";
    public login_pass_msg : string = "";
    public show_login_pass : boolean = false;
    public show_login_fail : boolean = false;
    public register = {name: "", phone: "", email: "", password: "",role:1, password_confirmation: ""};
    // public name_re = /^[a-zA-Z]+ [a-zA-Z]+$/;
    public email_re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
    public phone_re = /\+?\d[\d -]{8,12}\d/;
    public acttoken : any;
    public reset = {email: "", password: "", password_confirmation: "", token: ""};

    constructor(private http: HttpClient , private router : Router, private sessionservice : SessionService, private actroute: ActivatedRoute){
        if (actroute.snapshot.params['acttoken'] !== undefined) {
            this.acttoken = actroute.snapshot.params['acttoken'];
        }
        else {
            this.acttoken = "";
        }
        
    }

    ngOnInit(){
        AOS.init();
        this.show_login_pass= false;
        this.show_login_fail= false;
        if(this.acttoken !== undefined && this.acttoken !== ""){
            this.activateAccount();
        }
    }

    public changeLoginEmail(value : any){
        this.login.email = value;
    }
    public changeLoginPassword(value : any){
        this.login.password = value;
    }
    public changeRegisterName(value: any){
        this.register.name = value;
    }
    public changeRegisterPhone(value: any){
        this.register.phone = value;
    }
    public changRegisterEmail(value: any){
        this.register.email = value;
    }
    public changeRegisterPassword(value: any){
        this.register.password = value;
    }
    public changeRegisterPasswordConfirm(value: any){
        this.register.password_confirmation = value;
    }
    public changeRegisterRole(value: any){
        this.register.role = value;
        
    }
    public loginSubmit(){
        this.show_login_pass = false;
        this.show_login_fail = false;
        if(this.login.email != "" && this.login.password != ""){
            let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
            let options = {headers: headers};
            let params = new URLSearchParams();
            params.append('email' , this.login.email);
            params.append('password' , this.login.password);
            let paramsString = params.toString();
            this.http.post(gutil.devapiUrl + '/api/w/v1/login' , paramsString , options).subscribe((data: any) => {
                if(data.obj !== undefined && data.obj != null && data.obj.id > 0){
                    this.fetchUserInfo(data.obj);
                }else{
                    this.show_login_fail = true;
                    this.login_fail_msg = data.messages[0].message;
                }
            },
            err => console.log(err)
            )
        }else{
            this.show_login_fail = true;
            if(this.login.email == "" && this.login.password != ""){
                this.login_fail_msg = "Please enter email id";
            }else if(this.login.password == "" && this.login.email != ""){
                this.login_fail_msg = "Please enter password";
            }else{
                this.login_fail_msg = "Please enter email and password";
            }
        }
    }

    public fetchUserInfo(usrData : any){
        this.http.get(gutil.devapiUrl + '/api/v1/user/info?api_token=' + usrData.api_token).subscribe((data: any) => {
            this.sessionservice.setUser(data.obj); 
            this.login.email = "";
            this.login.password = "";
            if(data.obj.role == 2){
                this.router.navigate(['/profile/owner']);
            }else{
                this.router.navigate(['/profile/tenant'])
            }
        })
    }

    public newUser(){
        document.getElementById('exisiting_user').style.display = "none";
        document.getElementById('new_user').style.display = 'block';
    }
    public exisitingUser(){
        document.getElementById('exisiting_user').style.display = "block";
        document.getElementById('new_user').style.display = 'none';
    }

    public registerSubmit(){
        let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
        let options = {headers: headers};
        let params = new URLSearchParams();
        for(let key in this.register){
            params.append(key , this.register[key]);
        }
        let paramsString = params.toString();
        this.http.post(gutil.devapiUrl + '/api/w/v1/adduser', paramsString, options).subscribe((data: any) => {
            if(data.obj != null){
                this.show_login_pass = true;
                this.login_pass_msg = "Registeration successful. Please verify your email address.";
                document.getElementById('exisiting_user').style.display = "block";
                document.getElementById('new_user').style.display = 'none';
                this.register.name = "";
                this.register.phone = "";
                this.register.email = "";
                this.register.password = "";
                this.register.password_confirmation=  "";
            }else{
                this.show_login_pass = false;
                this.show_login_fail = true;
                this.login_fail_msg = "Something went wrong. Please try again."
            }
        })
    }
    public registerValidation(){
        this.show_login_fail = false;
        if(this.register.email != "" && this.register.name != "" && this.register.password != "" && this.register.password_confirmation != "" && this.register.phone != ""){
            if(this.register.name != ""){
                if(this.email_re.test(this.register.email)){
                    if(this.register.password.length >= 8){
                        if(this.register.password === this.register.password_confirmation){
                            if(this.phone_re.test(this.register.phone)){
                                this.show_login_fail = false;
                                this.registerSubmit();
                            }else{
                                this.show_login_fail = true;
                                this.show_login_pass = false;
                                this.login_fail_msg = "Please enter a valid phone number";
                            }
                        }else{
                            this.show_login_fail = true;
                            this.show_login_pass = false;
                            this.login_fail_msg = "Passwords do not match";
                        }
                    }else{
                        
                        this.show_login_fail = true;
                        this.show_login_pass = false;
                        this.login_fail_msg = "Password must contain minimun 8 characters";
                    }
                }else{
                    this.show_login_fail = true;
                    this.show_login_pass = false;
                    this.login_fail_msg = "Please enter a valid email id";
                }
            }else{
                this.show_login_fail = true;
                this.show_login_pass = false;
                this.login_fail_msg = "Please enter first and last name";
            }
        }else{
            this.show_login_fail = true;
            this.show_login_pass = false;
            this.login_fail_msg = "Please make sure you have filled all fields";
        }
    }

    public goBack(){
        this.router.navigate(['']);
    }

    public activateAccount(){
        if(this.acttoken != ""){
            this.http.get(gutil.devapiUrl + '/api/w/v1/register/verify/' + this.acttoken ).subscribe((data: any) => {
                this.show_login_fail = false;
                this.show_login_pass = true;
                this.login_pass_msg = "Email successfully verified. Please login to your account.";
            })
        }
    }
    // forgot password
    public forgotPassword(){
        this.show_login_fail = false;
        this.show_login_pass = false;
        this.login_fail_msg = "";
        this.login_pass_msg = "";
        console.log('hi');
        if(this.login.email != "" ){
            this.login_pass_msg = 'Password reset link sent to your email.';
            this.show_login_pass = true;
            let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
            let options = {headers : headers};
            let params = new URLSearchParams();
            params.append('email' , this.login.email);
            let paramsString = params.toString();
            this.http.post(gutil.devapiUrl + '/api/w/v1/password/email', paramsString , options).subscribe((data : any) => {
            
            })
        }else{
            this.login_fail_msg = 'Please fill your email id to recieve reset link.'
            this.show_login_fail = true;
        }
    }

    public resendActivation(){
        this.show_login_fail = false;
        this.show_login_pass = false;
        if(this.login.email != ""){
            this.http.get(gutil.devapiUrl + '/api/w/v1/register/resend/' + this.login.email).subscribe((data:any) => {
                if(data.obj != -1){
                    this.show_login_pass = true;
                    this.show_login_fail = false;
                    this.login_pass_msg = "Verification link sent. Please check your email."
                }else{
                    this.show_login_pass = false;
                    this.show_login_fail = true;
                    this.login_fail_msg = "Verfication mail already sent. If you did not recieve a verification link and cannot log in to the account, please contanct our sales team.";
                }
            })
        }else{
            this.show_login_fail = true;
            this.show_login_pass = false;
            this.login_fail_msg = "Please fill in your email id."
        }
    }
    
}